import * as service from './service'
export default {
  namespace: 'shansongStudyStudyRecord',
  state: {
    recordData: []
  },
  effects: {
    * getRecordList ({ payload }, { call, put }) {
      const res = yield call(service.getRecordList, payload)
      yield put({
        type: 'save',
        payload: {
          recordData: res.data.data
        }
      })
      return res.data
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
